import {
  PaddleEventData,
  Paddle as PaddleType,
  initializePaddle,
} from '@paddle/paddle-js';
import { useEffect, useRef, useState } from 'react';
import { environment } from '../constants';

export const usePaddle = ({
  eventCallback,
}: {
  eventCallback?: (
    paddleRef: React.MutableRefObject<PaddleType>,
    event: PaddleEventData
  ) => void;
}) => {
  const [Paddle, setPaddle] = useState<PaddleType>();
  const paddleRef = useRef<PaddleType>(null);

  useEffect(() => {
    const callback = (event: PaddleEventData) => {
      if (typeof eventCallback === 'function') {
        eventCallback(paddleRef as any, event);
      }
    };
    initializePaddle({
      environment: environment === 'production' ? 'production' : 'sandbox',
      token:
        environment === 'production'
          ? 'live_c09c7f49696dec7d2d94eba25af'
          : 'test_a2e0666674279c8493b9e8c87b1',
      eventCallback: callback,
    }).then((paddleInstance: PaddleType | undefined) => {
      if (paddleInstance) {
        setPaddle(paddleInstance);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        paddleRef.current = paddleInstance;
      }
    });
  }, [eventCallback]);

  return {
    Paddle,
  };
};
